import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import { getAddressParams } from 'utils/helper'

import type { NewAccountFormValues } from './model'

/**
 * The billing-address half of the New account drawer: watches the toggle and every billing field and
 * fills them from a Google Places selection. Needs a `FormProvider` over `NEW_ACCOUNT_INITIAL_STATE`.
 */
export const useBillingAddressFormFields = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<NewAccountFormValues>()

  const watchUseAsBillingAddress = watch('useAsBillingAddress')
  const watchBillingLine1 = watch('billingAddress.line1')
  const watchBillingCity = watch('billingAddress.city')
  const watchBillingState = watch('billingAddress.state')

  const handleBillingAddressFieldChange = useCallback(
    (address: unknown) => {
      const { line1, city, state, zipCode, country, longitudeFixed, latitudeFixed } = getAddressParams(address)
      setValue('billingAddress.line1', line1, { shouldDirty: true })
      setValue('billingAddress.city', city, { shouldDirty: true })
      setValue('billingAddress.state', state, { shouldDirty: true })
      setValue('billingAddress.country', country, { shouldDirty: true })
      setValue('billingAddress.zipCode', zipCode, { shouldDirty: true })
      setValue('billingAddress.latitude', latitudeFixed, { shouldDirty: true })
      setValue('billingAddress.longitude', longitudeFixed, { shouldDirty: true })
    },
    [setValue]
  )

  return {
    watchUseAsBillingAddress,
    watchBillingLine1,
    watchBillingCity,
    watchBillingState,
    billingAddressErrors: errors?.billingAddress,
    handleBillingAddressFieldChange,
  }
}
